import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { ConfigurationSaisieDonneesAnalyse, ModeSaisie } from '../../bo/configurationSaisieDonneesAnalyse';
import { DonneeAnalyse } from '../../bo/donneeAnalyse';
import { Dossier } from '../../bo/dossier';
import { Projet } from '../../bo/projet';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { Rotation } from '../../bo/rotation';
import { WorkflowModele } from '../../bo/workflowModele';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { ProjetModaleComponent } from '../projet-modale/projet-modale.component';
import { AccessPermissionType } from 'src/app/bo/accessPermisionType';
import { ItemSortHelper } from 'src/app/utils/itemSortHelper';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import Keycloak from 'keycloak-js';
import { KpiService } from 'src/app/services/kpi.service';

@Component({
  selector: 'app-projet-detail',
  templateUrl: './projet-detail.component.html',
  styleUrls: ['./projet-detail.component.scss'],
  standalone: false
})
export class ProjetDetailComponent {
  projet = input<Projet>();
  siteId = input<number>();
  
  estClient = input<boolean>(false);
  modaleAjout: BsModalRef;
  tab: number;
  
  donneesAnalyseProjet: DonneeAnalyse[] = [];
  configSaisieSite: ConfigurationSaisieDonneesAnalyse[] = [];
  initAnalyseFaite = false;
  initSuiviFaite = false;
  initDossierFaite = false;
  tabRotations: Rotation[];
  propDonneeSuivi: ProprieteAffichee[];
  hauteurListe: number;
  dossierRacine: Dossier;
  tabModeSaisieProjet: string[] = [];
  ancienProjet: Projet;
  private readonly keycloak = inject(Keycloak);

  constructor(private readonly userDataService: UtilisateurService,private readonly userService: KeycloakUtilisateurService
    ,  private readonly http: HttpService, private readonly modalService: BsModalService, router: Router,
    private readonly fonctionsService: FonctionsService, private readonly traductionService: TraductionService,private readonly translate: TranslateService,
  private readonly KpiService: KpiService) {
    modalService.onHide.observers = [];
    modalService.onHide.subscribe((raison: string) => {
      if (this.modaleAjout && this.modaleAjout.content && !this.modaleAjout.content.annul) {
        if (this.modaleAjout.content.suppression == true && this.modaleAjout.content.success == true) {
          router.navigate(['mysite', this.userDataService.currentSite()?.siteId, 'myprojects']);
        } else if (this.modaleAjout.content.suppression == false && this.modaleAjout.content.success == true)
          Object.assign(this.projet, this.modaleAjout.content.projet);
        this.modaleAjout = null;
      }
    });
    this.getScreenSize();
  }

  // si la fenêtre change de taille
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
      this.hauteurListe = 100;
  }

  ngOnChanges() {
    setTimeout(() => {
      if (this.projet() && this.projet() != this.ancienProjet) {
        this.initAnalyseFaite = false;
        this.changerTab(1);
      }
      else if (this.projet() != null) {
        this.changerTab(1);
      }
    });
  }

  ouvrirModaleModif() {
    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    let projet = this.http.get<Projet>('Projects/' + this.projet().projetId);
    let workflows = this.http.get<WorkflowModele[]>('Sites/' + this.siteId() + '/WorkflowModeles');
    forkJoin([projet, workflows]).subscribe(resultats => {
      let proj = resultats[0];
      if (proj.dateDebutPrevisionnelle)
        proj.dateDebutPrevisionnelle = new Date(proj.dateDebutPrevisionnelle);
      if (proj.dateFinPrevisionnelle)
        proj.dateFinPrevisionnelle = new Date(proj.dateFinPrevisionnelle);
      if (proj.dateDebutEffective)
        proj.dateDebutEffective = new Date(proj.dateDebutEffective);
      if (proj.dateFinEffective)
        proj.dateFinEffective = new Date(proj.dateFinEffective);
      let tabWorkflows = resultats[1];
      tabWorkflows.forEach(wkfw => wkfw.nomDate = wkfw.nom + ' (' + wkfw.dateDerniereModification + ')');
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
      var initialState = {
        estModif: true,
        projet: proj,
        siteId: this.siteId(),
        workflows: resultats[1]
      };
      this.modaleAjout = this.modalService.show(ProjetModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState });
    }, () => this.fonctionsService.loading_screen(false));
  }

  changerTab(numTab: number) {
    if (numTab == 1 && !this.initAnalyseFaite) {
      this.chargerDonneesAnalyse();
      this.tab = 1;
    } else if (numTab == 2 && !this.initSuiviFaite) {
      this.chargerDonneesSuivi();
      this.tab = 2;
    } else if (numTab == 3 && !this.initDossierFaite) {
      this.chargerDossier();
      this.tab = 3;
    }
    else
      this.tab = numTab;
  }

  chargerDonneesAnalyse() {
    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    let donneesAnalyseProjet = this.KpiService.getProjectAnalysisData(this.projet().projetId);
    let configSaisieSite = this.KpiService.getSiteConfigAnalysisEntry(this.siteId());

    const isGuest = !this.keycloak.hasRealmRole('access_all_kpi')
    forkJoin([donneesAnalyseProjet, configSaisieSite]).subscribe(resultats => {
      this.traductionService.translate.get(['GLOBAL.MOYENNE', 'GLOBAL.SOMME', 'GLOBAL.MINIMUM', 'GLOBAL.MAXIMUM', 'GLOBAL.MANUELLE']).subscribe(async res => {
        this.tabModeSaisieProjet = res;
        
       
        resultats[0].forEach(donnee => {
          let config = resultats[1].find(o => o.referentielDonneeAnalyseId == donnee.referentielDonneeAnalyseId);
          
            donnee.isEnabled = config.isEnabled;
            donnee.accessPermission = config.accessPermission;
         
            donnee.autorisePourUtil = ( (isGuest && config.accessPermission === AccessPermissionType.READANDWRITE) || (!isGuest && config.isEnabled)) && config.modeSaisieDonneeProjet == ModeSaisie.Manuelle;

          switch (config.modeSaisieDonneeProjet) {
            case ModeSaisie.Manuelle:
              donnee.modeSaisie = this.tabModeSaisieProjet['GLOBAL.MANUELLE'];
              break;
            case ModeSaisie.Max:
              donnee.modeSaisie = this.tabModeSaisieProjet['GLOBAL.MAXIMUM'];
              break;
            case ModeSaisie.Min:
              donnee.modeSaisie = this.tabModeSaisieProjet['GLOBAL.MINIMUM'];
              break;
            case ModeSaisie.Somme:
              donnee.modeSaisie = this.tabModeSaisieProjet['GLOBAL.SOMME'];
              break;
            case ModeSaisie.Moyenne:
              donnee.modeSaisie = this.tabModeSaisieProjet['GLOBAL.MOYENNE'];
              break;
            default:
              break;
          }
        });
        resultats[0].sort((a, b) => {
          if (a.autorisePourUtil && b.autorisePourUtil || !a.autorisePourUtil && !b.autorisePourUtil)
            return a.referentielDonneeAnalyse.nom.localeCompare(b.referentielDonneeAnalyse.nom);
          else if (a.autorisePourUtil && !b.autorisePourUtil)
            return -1;
          else if (!a.autorisePourUtil && b.autorisePourUtil)
            return 1;
        });

        try {
          resultats[0] = await ItemSortHelper.sortKpi(resultats[0]);
        } catch (error) {}

        this.fonctionsService.loading_screen(false);
        clearTimeout(startLoader);
        this.initAnalyseFaite = true;
        this.donneesAnalyseProjet = resultats[0];
        this.configSaisieSite = resultats[1];
        let donneeNonRenseignee = false;
        this.ancienProjet = this.projet();
        this.donneesAnalyseProjet.forEach((donnee) => {
          if (donnee.valeur === '' || donnee.donneeAnalyseId === -1)
            donneeNonRenseignee = true;
        });
        this.userDataService.currentProjet.donneeAnalyseRenseignees = !donneeNonRenseignee && this.donneesAnalyseProjet.length > 0;
      });
    }, () => {
      this.fonctionsService.loading_screen(false);
    });
  }

  chargerDonneesSuivi() {
    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    this.propDonneeSuivi = new Rotation().getProprietesAffichees();

    this.http.get<Rotation[]>('Projects/' + this.projet().projetId + '/Rotations').subscribe(rotations => {
      this.tabRotations = rotations;
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
      this.initSuiviFaite = true;
    }, () => {
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    });
  }

  chargerDossier() {
    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    this.http.get<Dossier>('Projects/' + this.projet().projetId + '/Folder').subscribe(dossier => {
      this.dossierRacine = dossier;
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
      this.initDossierFaite = true;
    }, (error:HttpErrorResponse) => {
      if(error.status === 401){
        this.translate.get('GLOBAL.NON_AUTORISE').subscribe(trad => {
          this.fonctionsService.launch_toast(false, false, trad)
          this.fonctionsService.loading_screen(false);
        });
      }






      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    });
  }

  modifDossier(d: Dossier) {
    this.dossierRacine = d;
  }
}
